import shuffle from 'lodash-es/shuffle';
import sortBy from 'lodash-es/sortBy';
import { fetchTests, fetchTest, fetchSignsQuestions } from './../api/tests.api.service';

export default {
  state: {
    tests: [],
    test: null,
    signsQuestions: [],
    removedSignsQuestionsIds: JSON.parse(localStorage.getItem('removed-signs-questions')) || []
  },
  getters: {
    getTest(state) {
      return state.test
    },
    getTests(state) {
      // exclude tests without questions
      return sortBy(state.tests
        .filter((test) => (test.questions || []).length), 'description')
    },
    getTestProgress(state) {
      if (!state.test) {
        return 0;
      }
      const totalQuestions = state.test.questions.length;
      const correctNumberOfAnswers = state.test.questions.reduce((acc, question) => {
        const correct = question.options.every((option) => {
          return !!option.is_correct === option.checked;
        });

        return acc + (correct ? 1 : 0);
      }, 0);

      return Number(
        ((correctNumberOfAnswers / totalQuestions) * 100).toFixed(2)
      );
    },
    getSignsQuestions(state) {
      return shuffle(state.signsQuestions.filter((question) => {
        return state.removedSignsQuestionsIds.indexOf(question._id) < 0;
      }));
    }
  },
  mutations: {
    setTest(state, test) {
      state.test = test;
    },
    setTests(state, tests) {
      state.tests = tests;
    },
    setSignsQuestions(state, questions) {
      state.signsQuestions = questions;
    },
    setRemovedQuestions(state, removedQuestionIds) {
      state.removedSignsQuestionsIds = removedQuestionIds;
    },
    updateTestAnswer(state, { question, option }) {
      const questionIndex = state.test.questions
        .findIndex((oldQuestion) => oldQuestion._id == question._id);
      const optionIndex = question.options
        .findIndex((oldOption) => oldOption._key === option._key);

      if (questionIndex < 0 || optionIndex < 0) {
        return;
      }

      question.options.splice(optionIndex, 1, option);
      state.test.questions.splice(questionIndex, 1, question);
    },
    updateSubmittedStatus(state, submitted) {
      state.test.submitted = submitted;
    }
  },
  actions: {
    async getTests(context) {
      const tests = await fetchTests()
      context.commit('setTests', tests);
      return tests
    },
    async getTest(context, { id }) {
      let [ test ] = await fetchTest(id);
      test = {
        ...test,
        questions: (test.questions || []).map((question) => {
          question.options = question.options.map((option) => ({
            ...option,
            checked: false
          }))
          return question;
        }),
        submitted: false
      };

      context.commit('setTest', test);
      return test;
    },
    async submitTest(context, { status }) {
      context.commit('updateSubmittedStatus', status);
    },
    async getSignsQuestions(context) {
      const { result } = await fetchSignsQuestions();
      context.commit('setSignsQuestions', result);
    },
    removeSignsQuestion(context, question) {
      const removedQuestionsIds = JSON.parse(localStorage.getItem('removed-signs-questions')) || [];
      removedQuestionsIds.push(question._id);
      context.commit('setRemovedQuestions', removedQuestionsIds);

      localStorage.setItem('removed-signs-questions', JSON.stringify(removedQuestionsIds));
    },
    resetRemovedQuestions(context) {
      context.commit('setRemovedQuestions', []);
      localStorage.setItem('removed-signs-questions', JSON.stringify([]));
    }
  }
}
